/** PickList form values are the target array; tolerate legacy `{ source, target }` shapes. */
export function normalizePickListSelection<T>(value: unknown): T[] {
	if (Array.isArray(value)) {
		return value;
	}
	if (value && typeof value === "object" && "target" in value) {
		const target = (value as { target?: unknown }).target;
		return Array.isArray(target) ? target : [];
	}
	return [];
}
